varying vec2 vUv;
varying float vElevation;
varying vec3 vColor; 


void main()
{
  #include <colorspace_fragment>

  vec3 color = clamp(vColor, 0.0, 1.0);

  gl_FragColor = vec4(color, 1.0);
}